import { render, staticRenderFns } from "./ContentNestedList.vue?vue&type=template&id=1838e149&scoped=true&"
import script from "./ContentNestedList.vue?vue&type=script&lang=js&"
export * from "./ContentNestedList.vue?vue&type=script&lang=js&"
import style0 from "./ContentNestedList.vue?vue&type=style&index=0&id=1838e149&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838e149",
  null
  
)

export default component.exports